<template>
  <div class="main">
    <div class="profileHeader">
      <Profile />
    </div>
    <div class="mainBody">
      <v-container class="cont">
        <v-card class="mx-auto cardfr" width="500">
          <v-card-title class="title font-weight-regular justify-space-between">
            <v-spacer></v-spacer>
            <span class="color">Nigeria Immigration Service (NIS)</span>
            <v-spacer></v-spacer>
            <img
              src="../assets/NIS.png"
              alt="teller logo"
              width="50"
              height="50"
            />
          </v-card-title>

          <v-window v-model="step">
            <v-window-item :value="1">
              <v-row>
                <v-col>
                  <div class="labelDiv">
                    <label class="lab"><b>Enter Application ID</b></label>
                  </div>
                  <v-text-field
                    @keyup.enter="enterClicked()"
                    v-model="appId"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-window-item>

            <v-window-item :value="2">
              <v-row>
                <v-col>
                  <div class="labelDiv">
                    <label class="lab"><b>Application ID</b></label>
                  </div>
                  <v-text-field
                    disabled
                    v-model="FrscItems.appID"
                    outlined
                  ></v-text-field>
                  <div class="labelDiv">
                    <label class="lab"><b>Expiry Date</b></label>
                  </div>
                  <v-text-field
                    disabled
                    v-model="FrscItems.expiryDate"
                    outlined
                  ></v-text-field>
                  <div class="labelDiv">
                    <label class="lab"><b>Ref No</b></label>
                  </div>
                  <v-text-field
                    disabled
                    v-model="FrscItems.refNo"
                    outlined
                  ></v-text-field>
                  <div class="labelDiv">
                    <label class="lab"><b>Amount</b></label>
                  </div>
                  <v-text-field
                    disabled
                    :value="DisplayCurrency(FrscItems.amount / 100)"
                    outlined
                  ></v-text-field>
                  <div class="labelDiv">
                    <label class="lab"><b>TXN ID</b></label>
                  </div>
                  <v-text-field
                    disabled
                    v-model="FrscItems.txnID"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-window-item>
          </v-window>

          <v-divider></v-divider>

          <v-card-actions>
            <v-avatar class="subheading white--text step" size="24">
              {{ step }}/2
            </v-avatar>
            <v-spacer></v-spacer>
            <v-btn
              class="nextBtn"
              dark
              v-if="step == 1"
              @click="NISAppValidationRequest()"
            >
              Next
            </v-btn>
            <v-btn text v-if="step == 2" @click="stepAdd(1)">
              back
            </v-btn>
            <v-btn class="nextBtn" dark v-if="step == 2" @click="NisPayment()">
              CONFIRM
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </div>
  </div>
</template>
<script>
import Profile from "../components/profileHeader";
import currencyFormatter from "currency-formatter";

export default {
  components: {
    Profile: Profile,
  },
  metaInfo: {
    title: "Teller/NIS",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  destroyed() {
    this.stepAdd(1);
  },
  data: () => ({
    appId: "",
  }),
  methods: {
    enterClicked() {
      this.NISAppValidationRequest();
    },
    DisplayCurrency(payload) {
      return currencyFormatter.format(payload, {
        code: "NGN",
      });
    },
    stepAdd(payload) {
      this.$store.commit("setNisStep", payload);
    },
    NISAppValidationRequest() {
      if (this.appId == "") {
        let payload = {
          status: true,
          message: "Fill out all the required fields",
        };
        this.$store.dispatch("SnackbarFunc", payload);
        return;
      }
      let payload = {
        applicationID: this.appId,
      };
      this.$store.dispatch("NISAppValidationRequest", payload);
    },

    NisPayment() {
      if (this.appId == "") {
        let payload = {
          status: true,
          message: "Fill out all the required fields",
        };
        this.$store.dispatch("SnackbarFunc", payload);
        return;
      }
      let payload = {
        applicationID: this.appId,
        customerID: this.User.customerID,
        pin: this.User.pin,
        route: this.$router,
      };
      this.$store.dispatch("NisPayment", payload);
    },
  },
  computed: {
    User() {
      return this.$store.getters.getUser;
    },
    step() {
      return this.$store.getters.getNisStep;
    },
    FrscItems() {
      return this.$store.getters.getNisItems;
    },
  },
};
</script>
<style scoped>
.main {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(90px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "profileHeader profileHeader profileHeader"
    "mainBody mainBody mainBody";
}
.profileHeader {
  grid-area: profileHeader;
  background-color: #faedf2;
  border-top-left-radius: 40px;
  height: 100px;
}
.mainBody {
  grid-area: mainBody;
  background-color: #ffffff;
  border-bottom-left-radius: 40px;
  padding: 50px;
  padding-top: 70px;
  height: 700px;
  overflow: scroll;
}

.mainBody::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}
.mainBody::-webkit-scrollbar-thumb {
  background: #ad1684;
  border-radius: 10px;
}

.cont {
  display: flex;
  justify-content: center;
  align-items: center;
}
.step {
  background-color: #ad1684;
  padding: 15px !important;
  color: white;
}
.cardfr {
  padding: 30px;
  box-shadow: 0 16px 50px 0 rgba(189, 36, 39, 0.11);
  background-color: #ffffff;
}
.title {
  margin-bottom: 40px;
}
.color {
  color: #ad1684;
  font-size: 18px;
}
.labelDiv {
  margin-bottom: 10px;
}
.nextBtn {
  background-color: #ad1684 !important;
  border-radius: 10px;
  text-transform: none;
}
@media only screen and (max-width: 1024px) {
  .mainBody {
    grid-area: mainBody;
    background-color: #ffffff;
    border-bottom-left-radius: 40px;
    padding: 30px;
    padding-top: 40px;
  }
  .color {
    color: #ad1684;
    font-size: 12px;
  }
  img {
    width: 25px;
    height: 25px;
  }
  .profileHeader {
    border-top-left-radius: 0px;
  }
  .mainBody {
    border-bottom-left-radius: 0px;
  }
}
</style>
